import { z } from "zod";
export const dmaBaseCompoundDtoSchema = z.object({
    compoundId: z.number(),
    moles: z.number(),
});
